import { reportError } from '@/services/error-reporting'

const captureUnhandledRejection = () => {
  window.onunhandledrejection = async (event) => {
    const errorMessage = event.reason?.message || event.reason || 'Unknown error'
    const errorStack = event.reason?.stack || 'No stack trace available'
    const currentUrl = window.location.href

    reportError('Unhandled promise rejection', {
      context: { errorMessage, errorStack, currentUrl, timestamp: new Date().toISOString() },
      tags: 'unhandled-promise-rejection'
    })

    event.preventDefault()
  }
}

export { captureUnhandledRejection }
